import React, { Component } from 'react';
import { animateScroll as scroll } from 'react-scroll';
const docBody = document.querySelector("body");

class Botao extends Component {

  componentDidMount() {
    scroll.scrollToTop();
  }

  constructor(props) {
    super(props);
    this.state = {
      control: false,
      texto: 'Dark',
      botao: 0,
    }
  }
  mudaStyle() {
    let color = this.control ? '#474747' : '#232323';
    docBody.style.backgroundColor = color;
    this.control ? this.control = false : this.control = true;
    this.mudaTexto();
  }
  mudaTexto() {
    this.control ? this.setState({ texto: 'Light' }) : this.setState({ texto: 'Dark' });
  }
  // Tenta passar variavel pro botao
  render() {
    return (
      <button className="link dark" onClick={() => this.mudaStyle()}> {this.state.texto} </button>
    );
  }
}

export default Botao;